import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Heading } from 'components/chroma';
import Section from 'scenes/payments/components/Section';
import Price from 'components/Price';
import { TextSmall } from 'components/chroma/extended';
import THEME from 'theme';
import { GovernmentChargesModal } from 'scenes/payments/components/Modal/GovernmentChargesModal';
import { toCurrency } from 'scenes/common/helpers/currency';

const PremiumDetailDiv = styled.div`
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PremiumTitleDiv = styled.div`
  flex-shrink: 1;
  justify-content: center;
`;

const RedTextWrapper = styled.div`
  p {
    color: ${THEME.LINK.DEFAULT} !important;
  }
`;

interface Props {
  price: string;
  gst: string;
  sd: string;
  fsl: string;
}
const headingStyle = { 'flex-shrink': 3, backGround: 'red' };

export default function PremiumDetail(props: Props) {
  const { price, gst, sd, fsl } = props;
  const [displayModal, setDisplayModal] = useState<boolean>(false);
  return (
    <>
      <GovernmentChargesModal
        isOpen={displayModal}
        onClose={() => setDisplayModal(false)}
        gst={gst}
        sd={sd}
        fsl={fsl}
      />
      <Section
        id="policy-premium"
        padding="1rem 2rem"
        justify
        margin="1rem 0rem 0rem"
      >
        <PremiumTitleDiv>
          <Heading style={headingStyle} size={2}>
            Your premium
          </Heading>
        </PremiumTitleDiv>
        <PremiumDetailDiv id="premium">
          <Price amount={toCurrency(parseFloat(price))} footnoteSymbol="*" />
          <Button
            link
            onClick={() => {
              setDisplayModal(true);
            }}
            margin={{ top: 1, bottom: 1 }}
          >
            <RedTextWrapper>
              <TextSmall>Show government charges</TextSmall>
            </RedTextWrapper>
          </Button>
        </PremiumDetailDiv>
      </Section>
    </>
  );
}
